import googleAnalytics from '@analytics/google-analytics';
import Analytics, { AnalyticsInstance } from 'analytics';

const analytics: AnalyticsInstance = Analytics({
  plugins: [
    googleAnalytics({
      measurementIds: ['G-ZHKW3VB29D'],
    }),
  ],
});

export default analytics;
